// src/api.ts
import { NamePath } from "antd/lib/form/interface";
import axios from "axios";
import { Notification } from "../config/Global";
import Message from "../config/Message";
import { FormInstance } from "antd";
import API_URL from "../config/ApiUrl";
import { CONSTANT } from "../config/Constant";
// import {refreshToken} from "./AuthSlice";

export type ErrorProps = {
  errors: {
    [key: string]: string[];
  };
  [key: string]: any;
};

export type FormattedErrorProps = {
  name: NamePath;
  errors: string[];
};

// Set your API base URL here
const BASE_URL = import.meta.env.VITE_REACT_APP_API_URL;

// Create an instance of axios with the base URL
const api = axios.create({
  baseURL: BASE_URL,
});



let isRefreshing = false;
let failedQueue: any = [];

const processQueue = (error: any, token = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};


// Add interceptors for request and response
api.interceptors.request.use(
  async (config: any) => {


    let authToken = localStorage.getItem("token");
    const timeIn = localStorage.getItem("timeIn");
    const lastUsed = localStorage.getItem("lastUsed");
    const elapsedSeconds = timeIn
      ? Math.round((Date.now() - Number(timeIn)) / 1000)
      : 0;

    const elapsedSecondsLastUsed = timeIn
      ? Math.round((Date.now() - Number(lastUsed)) / 1000)
      : 0;

    const tokenRefreshTime = CONSTANT.TOKEN_REFRESH_TIME;
    const expired = CONSTANT.TOKEN_EXPIRED_TIME;


    console.log('tokenRefreshTime',elapsedSeconds,'>', tokenRefreshTime ,'&&',elapsedSecondsLastUsed,'<', expired );
    // ---- Refresh if token expired ----
    if (authToken && elapsedSeconds > tokenRefreshTime && elapsedSecondsLastUsed< expired ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            config.headers = {
              ...config.headers,
              Accept: "application/json",
              Authorization: "Bearer " + token,
            };
            return config;
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;
      try {
        const { data } = await axios.get(API_URL.REFRESH_TOKEN, {
          baseURL: BASE_URL,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + authToken,
          }
        });

        const newToken = data.data.token;
        localStorage.setItem("token", newToken);
        localStorage.setItem("timeIn", Date.now().toString());
        localStorage.setItem("last refreshtime", new Date().toString());

        api.defaults.headers.common["Authorization"] = "Bearer " + newToken;
        processQueue(null, newToken);

        config.headers = {
          ...config.headers,
          Accept: "application/json",
          Authorization: "Bearer " + newToken,
        };
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem("token");
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    } else if (authToken) {
      // Not expired, just attach token
      config.headers = {
        ...config.headers,
        Accept: "application/json",
        Authorization: "Bearer " + authToken,
      };
    } else {
      config.headers = {
        ...config.headers,
        Accept: "application/json",
      };
    }

    // Always attach timezone
    config.headers["Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localStorage.setItem("lastUsed", new Date().getTime().toString());
    localStorage.setItem("last api called", new Date().toString());

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (response.data?.STATUS?.NOTIFICATION) {
      response.data.STATUS.NOTIFICATION.map((err: string) =>
        Notification.success({
          message: err,
        })
      );
    }
    // Process response data before returning
    return response;
  },
  (error) => {
    if (['ERR_CANCELED', 'ECONNABORTED'].includes(error.code)) {
      return new Promise(() => { }); // Or return a new promise that never resolves: return new Promise(() => {});
    }
    if (error.response) {
      if (
        error.response.data &&
        error.response.data?.STATUS?.NOTIFICATION
      ) {
        error.response.data.STATUS.NOTIFICATION.map((err: string) =>
          Notification.error({
            message: err,
          })
        );
      }


      if (error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("timeIn");
        setTimeout(() => {
          location.reload()
        }, 1000)
      }
      else if (error.response.status === 422 || error.response.status === 423) {
        //
      } else if (error.response.status === 500) {
        Notification.error({
          message: "Something Went Wrong",
        });
      }
      else if (error.response.status === 429) {
        Notification.error({
          message: Message().global.tooManyRequests,
        });
      } else if (
        error.response.data &&
        error.response.data?.STATUS?.NOTIFICATION
      ) {

      } else {
        Notification.error({
          message: Message().global.networkIssue,
        });
      }

      return Promise.reject(error.response);
    } else {
      Notification.error({
        message: Message().global.networkIssue,
      });
      return Promise.reject({
        data: [],
        message: Message().global.networkIssue,
      });
    }
  }
);

export const assignErrorToInput = (form: FormInstance, errors?: ErrorProps) => {
  const formattedErrors: FormattedErrorProps[] = [];
  if (errors) {
    Object.keys(errors).forEach((key) => {
      formattedErrors.push({
        name: key,
        errors: errors[key],
      });
    });
    formattedErrors.forEach((x) => {
      if (typeof x.name === "string" && x.name.indexOf(".") !== -1) {
        const name: any = x.name.split(".");
        name.forEach((e: any) => {
          if (!isNaN(parseInt(e))) {
            e = parseInt(e);
          }
        });
      }
    });
  }
  return form.setFields(formattedErrors);
};

export default api;
